import { Button, Col, Row, Spinner } from "react-bootstrap";
import { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from 'react-router-dom'
import { ApiErrorResponse } from "../../../types/ApiErrorResponse";
import { RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { setHideFilter } from "../../../redux/filtersSlice";
import SpinerLoader from "../../../components/SpinerLoader";
import FiltersContainer from "../../../components/Filters/components/FiltersContainer";
import { useFilterSurveyImportDetails } from "../hooks/useFilterSurveyImportDetails";
import SurveyImportDetailTable from "../components/SurveyImportDetailTable";
import { useGetSurveyImportDetails } from "../hooks/useGetSurveyImportDetails";
import { processAISurveys } from "../api/surveyImportAPI";
import { useAlert } from "../../../hooks/useAlert";
import AlertMessage from "../../../components/AlertMessage";
import { useQueryClient } from "@tanstack/react-query";
import ModalGlobal from "../../../components/AppModal/ModalGlobal";

export default function SurveyImportDetail() {
    const { t } = useTranslation();
    const { surveyImportId } = useParams<{ surveyImportId: string }>();
    const { alert, hideAlert, isVisible, showAlert } = useAlert({ fromLocation: true });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const { data: filters, isLoading: isFetchingDetailSurveyLoads } = useFilterSurveyImportDetails();
    const dispatch = useDispatch()
    const currentPage = useSelector((state: RootState) => state.historical.detailSurveyLoads.currentPage);
    const itemsPerPage = useSelector((state: RootState) => state.historical.detailSurveyLoads.itemsPerPage);

    const [isFilterVisible, setIsFilterVisible] = useState<boolean>(false)
    const isHideFilter = useSelector((state: RootState) => state.filters.detailSurveyLoads.hideFilter);


    const [showModalProcessAI, setShowModalProcessAI] = useState(false);
    const handleOpenProcessAI = () => setShowModalProcessAI(true);
    const handleCloseProcessAI = () => setShowModalProcessAI(false);

    const { data: surveyLoadDetailDto, error, isError } = useGetSurveyImportDetails({
        surveyImportId: surveyImportId ?? '',
    });


    useEffect(() => {
        if (isError) {
            setLoading(false);
            showAlert({
                message: error?.message ?? t("common:requestError.errorBadRequest"),
                type: "danger",
                duration: 8000
            });
        }
    }, [isError, error]);

    const handleClick = () => {
        dispatch(setHideFilter({ table: 'surveyLoads', hide: false }));
        setIsFilterVisible(!isFilterVisible);
    };

    const onGoBackClick = async () => {
        navigate("/survey-load");
    }

    const handleSurveyProcessAI =async () => {
        try {
            handleCloseProcessAI();
            setLoading(true);
            await processAISurveys(surveyImportId);
            setLoading(false);
            showAlert({
                message: t("survey:surveyImportDetail.messageSurveysProcessByIA"),
                type: "success",
                duration: 8000
            })
            queryClient.invalidateQueries({
                queryKey: ['getSurveyImportDetails'],
                exact: false,
                refetchType: 'all',
            });
     
        } catch (error) {
            setLoading(false);
            const fetchError = error as ApiErrorResponse;
            showAlert({
                message: fetchError.message ?? t("common:requestError.errorBadRequest"),
                type: "danger",
                duration: 8000
            })
        }
    }
    return (
        <>
            {loading && (
                <div className="overlay-spinner">
                    <Spinner animation="border" variant="light" />
                </div>
            )}
            <ModalGlobal
                show={showModalProcessAI}
                onClose={handleCloseProcessAI}
                body={t("survey:load.modalTitleProcessAI", { count: surveyLoadDetailDto?.totalSurveyImportToAIProcess })}
                onSave={() => {
                    handleSurveyProcessAI();
                }}
                saveText={t("common:buttons.buttonYes")}
                closeText={t("common:buttons.buttonNo")}
                isLoading={false}
            />
            <Row>
                <Col className="text-center" xs={12} md={12}>
                    {isVisible && (
                        <AlertMessage
                            message={alert!.message}
                            type={alert!.type}
                            onClose={hideAlert}
                        />
                    )}
                </Col>
            </Row>
            

            {isFetchingDetailSurveyLoads || !surveyLoadDetailDto  ||  surveyLoadDetailDto.surveyLoadLines === null  ? (
                <div className="justify-content-center">
                    <SpinerLoader />
                </div>
            ) : (
                <div>
                    <Row>
                        <Col xs={9} md={9}>
                            <h2>{t("survey:surveyImportDetail.titleLoad")}</h2>
                        </Col>

                        <Col xs={3} md={3} className="d-flex justify-content-end">
                            <Button
                                variant="secondary"
                                onClick={() => onGoBackClick()}
                                style={{ height: "38px" }}
                            >
                                {t("common:buttons.buttonBack")}
                            </Button>

                            <Button
                                variant="primary"
                                className="ms-2 mr-4"
                                style={{ height: "38px" }}
                                onClick={() => handleOpenProcessAI()}
                            >
                                {t("survey:surveyImportDetail.buttonProcessAI")}
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className="text-end mt-3" >
                            <Button variant="" onClick={handleClick} aria-controls="collapse-filter-id">
                                <img
                                    src="/filter.png"
                                    alt="Filtrar"
                                    style={{ width: '50px' }}
                                />
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        {!isHideFilter && filters && (
                            <div className="dashboard-section">
                                <FiltersContainer
                                    filters={filters}
                                    isFilterVisible={isFilterVisible && !isHideFilter}
                                    tableKey="detailSurveyLoads"
                                    historicalKey="detailSurveyLoads"
                                />
                            </div>
                        )}
                    </Row>
                    <SurveyImportDetailTable
                            surveyData={surveyLoadDetailDto.surveyLoadLines}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                        />
                    
                </div>
            )}
            
        </>
    );
}


